/**
 * 来店日時 (date: "YYYY-MM-DD", time: "HH:mm") を表示言語に応じた形式に整形する。
 * 日本語・中国語は「YYYY年M月D日 HH:mm」、英語は「Month D, YYYY at H:mm AM/PM」のように
 * 言語ごとに適切な表記が異なるため、Intl.DateTimeFormat の dateStyle/timeStyle に委譲する。
 *
 * `new Date("YYYY-MM-DDTHH:mm")` (タイムゾーン指定なし) は実行環境のローカルタイムゾーンで
 * 解釈されるため、環境によって表示が入力値からずれ得る。date/time を手動で分解して
 * `Date.UTC` で組み立て、`Intl.DateTimeFormat` 側にも `timeZone: "UTC"` を指定することで、
 * 実行環境に依存せず入力した date/time をそのまま表示する。
 */
export function formatReservationDateTime(date: string, time: string, language: string): string {
  const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  const timeMatch = /^(\d{2}):(\d{2})$/.exec(time);
  if (!dateMatch || !timeMatch) return "";

  const [, year, month, day] = dateMatch;
  const [, hour, minute] = timeMatch;
  const yearNum = Number(year);
  const monthNum = Number(month);
  const dayNum = Number(day);
  const hourNum = Number(hour);
  const minuteNum = Number(minute);

  const parsed = new Date(Date.UTC(yearNum, monthNum - 1, dayNum, hourNum, minuteNum));
  // Date.UTC は月=13 や日=40 のような範囲外の値も繰り上げて正規化してしまうため、
  // 生成した Date の各 UTC 要素が入力値と一致するかで不正な日時を弾く。
  const isValid =
    parsed.getUTCFullYear() === yearNum &&
    parsed.getUTCMonth() === monthNum - 1 &&
    parsed.getUTCDate() === dayNum &&
    parsed.getUTCHours() === hourNum &&
    parsed.getUTCMinutes() === minuteNum;
  if (!isValid) return "";

  return new Intl.DateTimeFormat(language, {
    dateStyle: "long",
    timeStyle: "short",
    timeZone: "UTC",
  }).format(parsed);
}
